import { ISchema } from 'kosmos/dialogs/CreateResourceModal';
import { IFilterField } from 'models/types';

export const userFilterSchema = (t: (key: string) => string): IFilterField[] => [
  {
    label: t('email'),
    name: 'email',
    widget: 'text',
  },
  {
    label: t('role'),
    name: 'role',
    widget: 'select',
    options: [
      { label: 'TFP', alias: 'tfp' },
      { label: 'Admin', alias: 'admin' },
      { label: 'Business', alias: 'sme' },
    ],
  },
];

export const userCreateSchema = (t: (key: string) => string): ISchema => ({
  fields: [
    { label: t('first-name'), name: 'firstName', widget: 'text', required: true },
    { label: t('last-name'), name: 'lastName', widget: 'text', required: true },
    { label: t('email'), name: 'email', widget: 'text', required: true },
    {
      label: t('organisation'),
      name: 'organisationId',
      widget: 'organisationSelector',
      required: true,
    },
    {
      label: t('role'),
      name: 'userRole',
      widget: 'select',
      required: true,
      placeholder: t('select-the-user-role'),
      description: t(
        'user-role-under-this-organisation-tfp-service-api-will-require-extra-setup-and-its-role-cannot-be-updated-later',
      ),
      options: [
        { alias: 'sme', label: t('business') },
        { alias: 'tfp', label: t('tfp-user') },
        { alias: 'serviceTfp', label: t('tfp-service-api') },
        { alias: 'orgAdmin', label: t('organisation-admin') },
      ],
    },
  ],
});
